export const giftCardHeaders = [
  {
    text: "Location Code",
    value: "location_code",
    width: "2rem"
  },
  {
    text: "Recipient Name",
    value: "recipient_name",
    width: "10rem"
  },
  {
    text: "Email",
    value: "email_address",
    width: "10rem"
  },
  {
    text: "Quoted Price",
    value: "rent_rate",
    width: "3rem"
  },
  {
    text: "GC Amount",
    value: "card_amount",
    width: "3rem"
  },
  {
    text: "Move-in Date",
    value: "move_in_date",
    width: "6rem"
  },
  {
    text: "Eligible On",
    value: "eligible_at",
    width: "6rem"
  },
  {
    text: "Status",
    value: "reward_status",
    width: "4rem"
  },
  {
    text: "Issue Date",
    value: "issued_at",
    width: "7rem"
  },
  {
    text: "Confirmation #",
    value: "confirmation_number",
    width: ""
  }
];
